import { QuestionBodyMultiSelect } from '@/features/advisor-onboarding/questionnaire/components/question-body-multi-select';
import { QuestionScreenLayout } from '@/features/advisor-onboarding/questionnaire/components/question-screen-layout';

import { useQuestionScreen } from '@/features/advisor-onboarding/questionnaire/contexts/question-screen-context';
import { useMultiSelectQuestion } from '@/features/advisor-onboarding/questionnaire/hooks/use-multi-select-question';

import { getOtherTextField } from '@/features/advisor-onboarding/questionnaire/lib/editable-other';

export function MultiSelectScreen() {
  const { question, resolved, answers, isSubmitting, submitAnswer } = useQuestionScreen();

  const initialValue = (answers[question.id] as string[] | undefined) ?? [];
  const otherKey = getOtherTextField(question.id);
  const initialOtherText = otherKey ? ((answers[otherKey] as string | undefined) ?? '') : '';
  const minSelections = question.type === 'multi-select' ? (question.minSelections ?? 0) : 0;
  const canSkip = !question.required || minSelections === 0;

  const { value, setValue, otherText, setOtherText, hasEditableOther, isValid, isEmpty, submit } =
    useMultiSelectQuestion({
      question,
      initialValue,
      initialOtherText,
      onSubmit: submitAnswer,
    });

  return (
    <QuestionScreenLayout
      onNext={submit}
      nextDisabled={!isValid}
      showSkip={canSkip && isEmpty}
    >
      <QuestionBodyMultiSelect
        options={resolved.options}
        value={value}
        onChange={setValue}
        otherValue={hasEditableOther ? otherText : undefined}
        onOtherValueChange={hasEditableOther ? setOtherText : undefined}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
